import React from "react";

export const mobileMenuItems = [
  {
    name: "ホーム",
    path: "/talent",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none">
        <defs>
          <clipPath id="clip0_10959_4494">
            <rect width="24" height="24" fill="white"/>
          </clipPath>
        </defs>
        <g mask="url(#mask0_18071_6071)">
          <path
            d="M6 18C6 18.5523 6.44772 19 7 19H8C8.55228 19 9 18.5523 9 18V14C9 13.4477 9.44772 13 10 13H14C14.5523 13 15 13.4477 15 14V18C15 18.5523 15.4477 19 16 19H17C17.5523 19 18 18.5523 18 18V10.5C18 10.1852 17.8518 9.88885 17.6 9.7L12.6 5.95C12.2444 5.68333 11.7556 5.68333 11.4 5.95L6.4 9.7C6.14819 9.88885 6 10.1852 6 10.5V18ZM5 21C4.44772 21 4 20.5523 4 20V9.5C4 9.18524 4.14819 8.88885 4.4 8.7L11.4 3.45C11.7556 3.18333 12.2444 3.18333 12.6 3.45L19.6 8.7C19.8518 8.88885 20 9.18524 20 9.5V20C20 20.5523 19.5523 21 19 21H14C13.4477 21 13 20.5523 13 20V16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16V20C11 20.5523 10.5523 21 10 21H5Z"
            fill="#BBBBBB"/>
        </g>
      </svg>
    ),
    iconSelect: (
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none">
        <g clipPath="url(#clip0_18071_1177)">
          <path d="M12.6 3.45C12.2444 3.18333 11.7556 3.18333 11.4 3.45L4.4 8.7C4.14819 8.88885 4 9.18524 4 9.5V20C4 20.5523 4.44772 21 5 21H8C8.55228 21 9 20.5523 9 20V15C9 14.4477 9.44772 14 10 14H14C14.5523 14 15 14.4477 15 15V20C15 20.5523 15.4477 21 16 21H19C19.5523 21 20 20.5523 20 20V9.5C20 9.18524 19.8518 8.88885 19.6 8.7L12.6 3.45Z"
            fill="#343A3D"/>
        </g>
        <defs>
          <clipPath id="clip0_18071_1177">
            <rect width="24" height="24" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    ),
    iconHover: (
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"
           fill="none">
        <g clipPath="url(#clip0_18071_1177)">
          <path
            d="M12.6 3.45C12.2444 3.18333 11.7556 3.18333 11.4 3.45L4.4 8.7C4.14819 8.88885 4 9.18524 4 9.5V20C4 20.5523 4.44772 21 5 21H8C8.55228 21 9 20.5523 9 20V15C9 14.4477 9.44772 14 10 14H14C14.5523 14 15 14.4477 15 15V20C15 20.5523 15.4477 21 16 21H19C19.5523 21 20 20.5523 20 20V9.5C20 9.18524 19.8518 8.88885 19.6 8.7L12.6 3.45Z"
            fill="#FF861A"/>
        </g>
        <defs>
          <clipPath id="clip0_18071_1177">
            <rect width="24" height="24" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    )
  },
  {
    name: "求人",
    path: "/talent/job",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"
           fill="none">
        <g clipPath="url(#clip0_18071_6078)">
          <path fillRule="evenodd" clipRule="evenodd"
                d="M14 6V4H10V6H14ZM4 8V19H20V8H4ZM20 6C21.11 6 22 6.89 22 8V19C22 20.11 21.11 21 20 21H4C2.89 21 2 20.11 2 19L2.01 8C2.01 6.89 2.89 6 4 6H8V4C8 2.89 8.89 2 10 2H14C15.11 2 16 2.89 16 4V6H20Z"
                fill="#BBBBBB"/>
        </g>
        <defs>
          <clipPath id="clip0_18071_6078">
            <rect width="24" height="24" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    ),
    iconSelect: (
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none">
        <g clipPath="url(#clip0_18071_5427)">
          <path d="M20 6H16V4C16 2.89 15.11 2 14 2H10C8.89 2 8 2.89 8 4V6H4C2.89 6 2.01 6.89 2.01 8L2 19C2 20.11 2.89 21 4 21H20C21.11 21 22 20.11 22 19V8C22 6.89 21.11 6 20 6ZM14 6H10V4H14V6Z"
            fill="#343A3D"/>
        </g>
        <defs>
          <clipPath id="clip0_18071_5427">
            <rect width="24" height="24" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    ),
    iconHover: (
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"
           fill="none">
        <g clipPath="url(#clip0_18071_5427)">
          <path
            d="M20 6H16V4C16 2.89 15.11 2 14 2H10C8.89 2 8 2.89 8 4V6H4C2.89 6 2.01 6.89 2.01 8L2 19C2 20.11 2.89 21 4 21H20C21.11 21 22 20.11 22 19V8C22 6.89 21.11 6 20 6ZM14 6H10V4H14V6Z"
            fill="#FF861A"/>
        </g>
        <defs>
          <clipPath id="clip0_18071_5427">
            <rect width="24" height="24" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    )
  },
  {
    name: "メッセージ",
    path: "/talent/message",
    noti: 14,
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"
           fill="none">
        <g clipPath="url(#clip0_18071_6084)">
          <path
            d="M18.3749 4.5H5.17494C4.26744 4.5 3.52494 5.2425 3.52494 6.15V21L6.82494 17.7H18.3749C19.2824 17.7 20.0249 16.9575 20.0249 16.05V6.15C20.0249 5.2425 19.2824 4.5 18.3749 4.5ZM18.3749 15.75H6.82494L5.39994 17.25V6.375H18.3749V15.75Z"
            fill="#BBBBBB"/>
        </g>
        <defs>
          <clipPath id="clip0_18071_6084">
            <rect width="24" height="24" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    ),
    iconSelect: (
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none">
        <g clipPath="url(#clip0_18071_5287)">
          <path d="M18.6 4.5H5.4C4.4925 4.5 3.75 5.2425 3.75 6.15V21L7.05 17.7H18.6C19.5075 17.7 20.25 16.9575 20.25 16.05V6.15C20.25 5.2425 19.5075 4.5 18.6 4.5Z"
            fill="#343A3D"/>
        </g>
        <defs>
          <clipPath id="clip0_18071_5287">
            <rect width="24" height="24" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    ),
    iconHover: (
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"
           fill="none">
        <g clipPath="url(#clip0_18071_5287)">
          <path
            d="M18.6 4.5H5.4C4.4925 4.5 3.75 5.2425 3.75 6.15V21L7.05 17.7H18.6C19.5075 17.7 20.25 16.9575 20.25 16.05V6.15C20.25 5.2425 19.5075 4.5 18.6 4.5Z"
            fill="#FF861A"/>
        </g>
        <defs>
          <clipPath id="clip0_18071_5287">
            <rect width="24" height="24" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    )
  },
  {
    name: "招待",
    path: "",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 -960 960 960" width="32" fill="#BBBBBB"><path d="M520-120v-80h80v80h-80Zm-80-80v-200h80v200h-80Zm320-120v-160h80v160h-80Zm-80-160v-80h80v80h-80Zm-480 80v-80h80v80h-80Zm-80-80v-80h80v80h-80Zm360-280v-80h80v80h-80ZM180-660h120v-120H180v120Zm-60 60v-240h240v240H120Zm60 420h120v-120H180v120Zm-60 60v-240h240v240H120Zm540-540h120v-120H660v120Zm-60 60v-240h240v240H600Zm80 480v-120h-80v-80h160v120h80v80H680ZM520-400v-80h160v80H520Zm-160 0v-80h-80v-80h240v80h-80v80h-80Zm40-200v-160h80v80h80v80H400Zm-190-90v-60h60v60h-60Zm0 480v-60h60v60h-60Zm480-480v-60h60v60h-60Z"/></svg>
    ),
    iconSelect: (
      <svg xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 -960 960 960" width="32" fill="#343A3D"><path d="M520-120v-80h80v80h-80Zm-80-80v-200h80v200h-80Zm320-120v-160h80v160h-80Zm-80-160v-80h80v80h-80Zm-480 80v-80h80v80h-80Zm-80-80v-80h80v80h-80Zm360-280v-80h80v80h-80ZM180-660h120v-120H180v120Zm-60 60v-240h240v240H120Zm60 420h120v-120H180v120Zm-60 60v-240h240v240H120Zm540-540h120v-120H660v120Zm-60 60v-240h240v240H600Zm80 480v-120h-80v-80h160v120h80v80H680ZM520-400v-80h160v80H520Zm-160 0v-80h-80v-80h240v80h-80v80h-80Zm40-200v-160h80v80h80v80H400Zm-190-90v-60h60v60h-60Zm0 480v-60h60v60h-60Zm480-480v-60h60v60h-60Z"/></svg>
    ),
    iconHover: (
      <svg xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 -960 960 960" width="32" fill="#FF861A"><path d="M520-120v-80h80v80h-80Zm-80-80v-200h80v200h-80Zm320-120v-160h80v160h-80Zm-80-160v-80h80v80h-80Zm-480 80v-80h80v80h-80Zm-80-80v-80h80v80h-80Zm360-280v-80h80v80h-80ZM180-660h120v-120H180v120Zm-60 60v-240h240v240H120Zm60 420h120v-120H180v120Zm-60 60v-240h240v240H120Zm540-540h120v-120H660v120Zm-60 60v-240h240v240H600Zm80 480v-120h-80v-80h160v120h80v80H680ZM520-400v-80h160v80H520Zm-160 0v-80h-80v-80h240v80h-80v80h-80Zm40-200v-160h80v80h80v80H400Zm-190-90v-60h60v60h-60Zm0 480v-60h60v60h-60Zm480-480v-60h60v60h-60Z"/></svg>
    )
  },
  {
    name: "マイページ",
    path: "/talent/mypage",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"
           fill="none">
        <g clipPath="url(#clip0_18071_5297)">
          <path
            d="M12 5.9C13.16 5.9 14.1 6.84 14.1 8C14.1 9.16 13.16 10.1 12 10.1C10.84 10.1 9.9 9.16 9.9 8C9.9 6.84 10.84 5.9 12 5.9ZM12 14.9C14.97 14.9 18.1 16.36 18.1 17V17.1C18.1 17.6523 17.6523 18.1 17.1 18.1H6.9C6.34771 18.1 5.9 17.6523 5.9 17.1V17C5.9 16.36 9.03 14.9 12 14.9ZM12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4ZM12 13C9.33 13 4 14.34 4 17V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V17C20 14.34 14.67 13 12 13Z"
            fill="#BBBBBB"/>
        </g>
        <defs>
          <clipPath id="clip0_18071_5297">
            <rect width="24" height="24" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    ),
    iconSelect: (
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none">
        <g clipPath="url(#clip0_18071_27246)">
          <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V18C20 15.34 14.67 14 12 14Z"
            fill="#343A3D"/>
        </g>
        <defs>
          <clipPath id="clip0_18071_27246">
            <rect width="24" height="24" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    ),
    iconHover: (
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"
           fill="none">
        <g clipPath="url(#clip0_18071_27246)">
          <path
            d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V18C20 15.34 14.67 14 12 14Z"
            fill="#FF861A"/>
        </g>
        <defs>
          <clipPath id="clip0_18071_27246">
            <rect width="24" height="24" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    )
  },
];
